<ion-header>
  <div class="upload-dialog-header">
    <div class="header-left">
      <div class="header-icon-box">
        <ion-icon name="images-outline"></ion-icon>
      </div>
      <div class="header-text">
        <ion-text class="header-kicker">Property Media</ion-text>
        <ion-text class="header-title">Property Images</ion-text>
      </div>
    </div>
    <ion-button fill="clear" class="header-close-btn" (click)="dismissdialog()">
      <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
    </ion-button>
  </div>
</ion-header>

<ion-content>
  <input hidden type="file" accept="image/jpeg,image/jpg,image/gif,image/png,image/x-eps" #filepicker
    (change)="fileSelected($event)" multiple />

  @if (isDataLoaded) {
  <div class="upload-page">

    <!-- Add Images Drop Zone -->
    <div class="upload-drop-zone" (click)="addFile()" role="button" tabindex="0"
      (keydown.enter)="addFile()" (keydown.space)="addFile()">
      <div class="upload-drop-inner">
        <div class="upload-drop-icon-wrap">
          <ion-icon name="cloud-upload-outline" class="upload-drop-icon"></ion-icon>
        </div>
        <ion-text class="upload-drop-title">Select images to upload</ion-text>
        <ion-text class="upload-drop-sub">JPG, PNG, GIF &bull; Tap to browse files</ion-text>
        <ion-button class="upload-browse-btn" fill="solid" (click)="$event.stopPropagation(); addFile()">
          <ion-icon slot="start" name="folder-open-outline"></ion-icon>
          Browse Files
        </ion-button>
      </div>
    </div>

    <!-- Selected / New Images Preview -->
    @if (imageUrls.length > 0) {
    <div class="upload-section">
      <div class="upload-section-heading">
        <div class="section-icon-box-sm">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
        </div>
        <div class="upload-section-label">
          <ion-text class="upload-section-kicker">Ready to Upload</ion-text>
          <ion-text class="upload-section-title">Selected Images</ion-text>
        </div>
        <div class="upload-badge">{{ imageUrls.length }}</div>
      </div>

      <ion-card class="upload-surface-card">
        <ion-card-content>
          <swiper-container class="upload-swiper" appSwiper1 #swiper1 loop="false" pagination="true"
            breakpoints='{"0":{"slidesPerView":1.2,"spaceBetween":10},"480":{"slidesPerView":2.15,"spaceBetween":12},"768":{"slidesPerView":3,"spaceBetween":14}}'>
            @for (imgUrl of imageUrls; track $index) {
            <swiper-slide class="upload-slide">
              <div class="upload-img-wrap">
                <img class="upload-img" [src]="imgUrl" onError="this.src='/assets/no-image.jpg';"
                  alt="Selected image {{ $index + 1 }}">
                <button class="upload-img-remove" (click)="removeImage($index)" aria-label="Remove image">
                  <ion-icon name="trash-outline"></ion-icon>
                </button>
              </div>
            </swiper-slide>
            }
          </swiper-container>
        </ion-card-content>
      </ion-card>
    </div>
    }

    <!-- Uploaded / Existing Gallery -->
    <div class="upload-section">
      <div class="upload-section-heading">
        <div class="section-icon-box-sm">
          <ion-icon name="cloud-done-outline"></ion-icon>
        </div>
        <div class="upload-section-label">
          <ion-text class="upload-section-kicker">Property Gallery</ion-text>
          <ion-text class="upload-section-title">Uploaded Images</ion-text>
        </div>
        <div class="upload-badge upload-badge-navy">{{ uploadedImages.length }}</div>
      </div>

      <ion-card class="upload-surface-card">
        <ion-card-content>
          @if (uploadedImages.length > 0) {
          <swiper-container class="upload-swiper" appSwiper #swiper loop="true"
            autoplay='{"delay":3000,"disableOnInteraction":false}' pagination="true"
            breakpoints='{"0":{"slidesPerView":1.2,"spaceBetween":10},"480":{"slidesPerView":2.15,"spaceBetween":12},"768":{"slidesPerView":3,"spaceBetween":14}}'>
            @for (item of uploadedImages; track $index) {
            <swiper-slide class="upload-slide">
              <div class="upload-img-wrap">
                <img class="upload-img" src="{{imageUrl+item.ImageName}}"
                  onError="this.src='/assets/no-image.jpg';" alt="Property image {{ $index + 1 }}">
                <button class="upload-img-remove upload-img-remove-danger" (click)="deleteImage(item.Id)"
                  aria-label="Delete image">
                  <ion-icon name="trash-outline"></ion-icon>
                </button>
              </div>
            </swiper-slide>
            }
          </swiper-container>
          } @else {
          <div class="upload-empty-state">
            <div class="upload-empty-icon-wrap">
              <ion-icon name="images-outline"></ion-icon>
            </div>
            <ion-text class="upload-empty-title">No images yet</ion-text>
            <ion-text class="upload-empty-sub">Uploaded images will appear here once saved</ion-text>
          </div>
          }
        </ion-card-content>
      </ion-card>
    </div>

  </div>
  }
</ion-content>

<ion-footer>
  <div class="upload-footer">
    <ion-button class="footer-btn footer-btn-cancel" fill="outline" (click)="dismissdialog()">
      <ion-icon slot="start" name="close-outline"></ion-icon>
      Cancel
    </ion-button>
    <ion-button class="footer-btn footer-btn-upload" [disabled]="!imageUrls || imageUrls.length === 0"
      (click)="uploadImages()">
      <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
      Upload {{ imageUrls.length > 0 ? imageUrls.length + (imageUrls.length > 1 ? ' Images' : ' Image') : 'Images' }}
    </ion-button>
  </div>
</ion-footer>